import {StackNavigator} from './navigation/StackNavigator';

function App() {
  return (
    <div className='container' style={{height: '100vh'}}>
      <StackNavigator />
    </div>
  );
}
export default App;

